import { useEffect, useState } from 'react';
import { Link, Outlet } from 'react-router-dom';
import ModalContent from '@/components/modals/ModalContent';
import { styled } from '@mui/material/styles';
import Snackbar from '@/components/Snackbar';
import { useBootstrap } from '../hooks/useBootstrap';
import PageLoader from '@/components/PageLoader';
import { Box } from '@mui/material';
import { useAppDispatch, useAppSelector } from '@/store/hooks';
import { logout } from '@/store/reducers/user/actions';
import config from '@/types/config';
import { selectUser } from '@/store/reducers/user/userSlice';
import { useExperiment } from '@/providers/ExperimentProvider';
import { FeatureFlags } from '@/constants/featureFlags';
import analytics from '@/utils/analytics/analyticsInstance';
import { useTrackPageLoadTime } from '@/hooks/useTrackPageLoadTime';

const Container = styled('div')`
  display: flex;
  flex-direction: column;
  flex: 1;
`;

const DevelopmentContainer = () => {
  const dispatch = useAppDispatch();
  const user = useAppSelector(selectUser);
  const {
    variant: testExperimentVariant,
    payload,
    isReady,
  } = useExperiment(FeatureFlags.LINK_BANK_ACCOUNT);

  const handleLogout_TESTING_ONLY = () => {
    dispatch(logout(null));
    window.location.reload();
  };

  if (config.nodeEnv !== 'development' || !isReady) return null;

  return (
    <>
      <Box sx={{ backgroundColor: '#ccc' }}>
        Testing mode:{' '}
        <Link to="#" onClick={handleLogout_TESTING_ONLY}>
          Logout
        </Link>{' '}
        UserID - {user?.id}
      </Box>
      <Box sx={{ backgroundColor: '#ccc' }}>
        <Box>Amplitude Experiment: link-bank-account</Box>
        <Box>Variant: {testExperimentVariant}</Box>
        <Box>Payload: {JSON.stringify(payload)}</Box>
      </Box>
    </>
  );
};

const MainLayout = () => {
  const { isLoading } = useBootstrap();
  const [fakeLoading, setFakeLoading] = useState(true);

  useTrackPageLoadTime('webOnboardingFullyLoaded');

  useEffect(() => {
    analytics.track('webOnboardingOpened');
  }, []);

  useEffect(() => {
    setTimeout(() => {
      setFakeLoading(false);
    }, 1000);
  }, []);

  if (isLoading || fakeLoading) {
    return <PageLoader text="Loading..." />;
  }

  return (
    <Container>
      <DevelopmentContainer />
      <Snackbar />
      <ModalContent />
      <Container>
        <Outlet />
      </Container>
    </Container>
  );
};

export default MainLayout;
